import { FC } from "react";
import { BuscarComponent } from "../../../../shared/providers/ListView/BuscarComponent";
import { AuditoriaTerceroHeaderToolbar } from "./AuditoriaTerceroHeaderToolbar";

export const TerceroManagamentHeader: FC = () => {
    
    return (
        <div className='card-header border-0 py-4'>
            <BuscarComponent placeholder="Buscar" />
            <div className='card-toolbar'>
                <AuditoriaTerceroHeaderToolbar />
            </div>
        </div>
    )
}